<template>
    <b-modal ref="mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent" :title="title" centered
        no-close-on-backdrop no-close-on-esc hide-header-close size="lg" @show="onShow">
        <b-row>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Metodo Pagamento</label>
                <span v-if="isReadOnly"> {{ jsonData.codiceMetodoPagamento }}</span>
                <b-form-input v-else v-model="jsonData.codiceMetodoPagamento"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Descrizione Metodo Pagamento</label>
                <span v-if="isReadOnly"> {{ jsonData.descrizioneMetodoPagamento }}</span>
                <b-form-input v-else v-model="jsonData.descrizioneMetodoPagamento"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="2" xl="2">
                <label class="sa-label-data">Fine Mese</label>
                <span v-if="isReadOnly"> {{ jsonData.fineMeseMetodoPagamento ? "Si" : "No" }}</span>
                <b-form-checkbox v-else switch v-model="jsonData.fineMeseMetodoPagamento"></b-form-checkbox>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="2" xl="2">
                <label class="sa-label-data">Data Fattura</label>
                <span v-if="isReadOnly"> {{ jsonData.dataFatturaMetodoPagamento ? "Si" : "No" }}</span>
                <b-form-checkbox v-else switch v-model="jsonData.dataFatturaMetodoPagamento"></b-form-checkbox>
            </b-col>
            <b-col cols="12" style="margin-top: 5px;">
                <b-card class="sa-card" header="Frazionamenti" header-tag="header" footer-tag="footer">
                    <template #header>
                        <div style="width: 100%; display: flow-root" h-align="center">
                            <span>Frazionamenti</span>

                            <b-button size="sm" variant="outline-success outline-primary-noborder float-sm-right"
                                :hidden="false" @click="onClickAggiungiFrazionamento" class="mb-2">
                                <font-awesome-icon icon="plus"> </font-awesome-icon>
                                Aggiungi Frazionamento
                            </b-button>
                        </div>
                    </template>

                    <b-table sticky-header ref="tblFrazionamenti" stacked="xl" striped hover itemscope
                        :items="jsonData.frazionamenti" :fields="fieldFrazionamenti" :current-page="1" :per-page="50"
                        sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="item">
                            {{ item.index + 1 }}
                        </template>
                        <template #cell(percentualeFrazionamentiPagamenti)="row">
                            <editable-cell :value="row.item.percentualeFrazionamentiPagamenti" :step="'0.1'" :max="'1'"
                                :min="'0.1'" type="number" @update="onUpdatePercentualeFrazione(row, $event)" />
                        </template>
                        <template #cell(numeroGiorniFrazionamentoPagamento)="row">
                            <editable-cell :value="row.item.numeroGiorniFrazionamentoPagamento" :step="'1'" :min="'0'"
                                type="number" @update="OnUpdateGiorniFrazionamentoPagamento(row, $event)" />
                        </template>
                        <template #cell(actions)="row">
                            <b-button v-if="row.index != jsonData.frazionamenti.lenght - 1" size="sm"
                                variant="btn btn-outline-danger waves-effect waves-light width-sm no-text"
                                @click="onClickDeleteFrazionamento(row)">
                                <b-icon icon="trash"></b-icon>
                            </b-button>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" :disabled="!isPercentualeFrazionamentoUno" variant="outline-success"
                @click="onOkMdlContabilitaIva">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import EditableCell from "../../utility/components/EditableCell.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
    components: { ModalError, EditableCell },
    data() {
        return {
            title: null,
            pathResource: "/contabilitametodipagamento",
            isReadOnly: false,
            isPercentualeFrazionamentoUno: false,
            jsonData: {
                codiceMetodoPagamento: "",
                descrizioneMetodoPagamento: "",
                fineMeseMetodoPagamento: false,
                dataFatturaMetodoPagamento: true,
                frazionamenti: []
            },
            marcaBolloOptions: [
                { text: "NO", value: "NO" },
                { text: "SI", value: "SI" },
            ],
            frazionamento: {
                numeroGiorniFrazionamentoPagamento: "0",
                percentualeFrazionamentiPagamenti: "0.1"
            },
            fieldFrazionamenti: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Numero Giorni Frazionamento",
                    key: "numeroGiorniFrazionamentoPagamento",
                    //thStyle: "width: 5rem",
                    sortable: false,
                    formatter: function (value) {
                        return value + " Giorni"
                    }
                },
                {
                    label: "Percentuale Giorni Frazionamento",
                    key: "percentualeFrazionamentiPagamenti",
                    //thStyle: "width: 5rem",
                    sortable: false,
                    formatter: function (value) {
                        if (value) {
                            value = value.toLocaleString("it-IT", { style: "percent" });
                        } else if (value === 0) {
                            value = value.toLocaleString("it-IT", { style: "percent" });
                        }
                        if (value > 0 && value <= 1) {
                            value = value * 100;
                            value = value.toLocaleString("it-IT", { style: "percent" });
                        }

                        return value;
                    },
                },
                { key: "actions", label: "", thStyle: "width: 4rem" },
            ]
        };
    },
    mounted() { },
    methods: {
        show(jsonData) {
            console.log(jsonData);

            let me = this;
            this.title = "Nuovo Metodo Pagamento";
            if (jsonData.id) {
                this.title = "Modifica Metodo Pagamento";
                this.jsonData = JSON.parse(JSON.stringify(jsonData));
                this.checkFrazionamenti();
            } else {
                this.resetJsonDataMetodoPagamento();
            }
            me.$refs.mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent.show();
        },
        onCloseModal() {
            let me = this;
            this.resetJsonDataMetodoPagamento();
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent.hide();
        },

        resetJsonDataMetodoPagamento() {
            this.jsonData = {
                codiceMetodoPagamento: "",
                descrizioneMetodoPagamento: "",
                fineMeseMetodoPagamento: false,
                dataFatturaMetodoPagamento: true,
                frazionamenti: []
            };
        },
        checkFrazionamenti() {
            if (this.jsonData.frazionamenti == 0) {
                let frazionamento = {
                    numeroGiorniFrazionamentoPagamento: "0",
                    percentualeFrazionamentiPagamenti: "1"
                }
                this.jsonData.frazionamenti.push(frazionamento)
            } else {
                this.isPercentualeFrazionamentoUno = false;
                let sommaFrazionamento = 0.0;
                for (let frazionamento of this.jsonData.frazionamenti) {
                    console.log("aggiungo", Number(frazionamento.percentualeFrazionamentiPagamenti));
                    console.log("sommaFrazionamento", sommaFrazionamento);

                    sommaFrazionamento += Number(frazionamento.percentualeFrazionamentiPagamenti);

                }

                console.log(sommaFrazionamento, " finale ");

                if (sommaFrazionamento == 1) {
                    this.isPercentualeFrazionamentoUno = true;
                }
                if (this.isPercentualeFrazionamentoUno) {
                    console.log("ok frazionamento corretto : " + sommaFrazionamento);

                }
            }
        },


        salvaMetodoPagamento(response) {
            let me = this;
            response;
            me.$refs.mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        salvaDocumentoCausaleError(error) {
            let me = this;
            me.$emit("saveDocumentoArticolo", error);
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        validazione() {
            let esito = true;
            let msg = "";
            if (this.jsonData.codiceMetodoPagamento == null || this.jsonData.codiceMetodoPagamento.trim() == "") {
                msg += "Codice Metodo Pagamento  non valido ! #";
                esito = false;
            }
            if (this.jsonData.descrizioneMetodoPagamento == null || this.jsonData.descrizioneMetodoPagamento.trim() == "") {
                msg += "Descrizione Metodo Pagamento  non valida ! #";
                esito = false;
            }

            return { esito: esito, msg: msg };
        },
        generaBtoast(validation) {
            let message = validation.msg.split("#");
            const h = this.$createElement;
            const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
            message.forEach((element) => {
                if (element.trim() != "") {
                    vNodesMsg.children.push({ tag: "li", text: element });
                }
            });
            this.$bvToast.toast([vNodesMsg], {
                title: "Attenzione!",
                autoHideDelay: 5000,
                variant: "danger",
            });
        },
        contabilitaTipoDocumentoLoadDataSuccess(response) {
            this.tipoDocumentoOptions = response.data.data;
            console.log(this.tipoDocumentoOptions);
        },
        onShow() { },

        onOkMdlContabilitaIva(bvModalEvent) {
            let me = this;
            bvModalEvent.preventDefault();
            let validation = me.validazione();
            if (!validation.esito) {
                me.generaBtoast(validation);
                return;
            }
            this.openShowModalLoading();
            this.$emit("beforeSave");
            this.saveResource(me.pathResource, me.jsonData, me.saveResourceSuccess, me.saveResourceError); //, me.saveResourceError
        },
        saveResourceSuccess() {
            this.$refs.mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent.hide();
            this.$emit("afterSave");
            this.closeShowModalLoading();
        },
        saveResourceError(error) {
            let message = error.response.data.messaggio;
            this.errorToast(message);
        },
        onClickDeleteFrazionamento(row) {
            console.log(row);
            this.jsonData.frazionamenti.splice(row.index, 1);
            this.checkFrazionamenti();
        },
        onClickAggiungiFrazionamento() {
            console.log("aggiungi frazionamento standard", this.jsonData);
            this.jsonData.frazionamenti.push(JSON.parse(JSON.stringify(this.frazionamento)))
            console.log(this.jsonData.frazionamenti);
            this.checkFrazionamenti();
        },
        onUpdatePercentualeFrazione(row, event) {
            this.jsonData.frazionamenti[row.index].percentualeFrazionamentiPagamenti = event;
            this.checkFrazionamenti();
        },
        OnUpdateGiorniFrazionamentoPagamento(row, event) {
            this.jsonData.frazionamenti[row.index].numeroGiorniFrazionamentoPagamento = event;
            this.checkFrazionamenti();
        }
    },
};
</script>
